export const PASSWORD_PATTERN = '^(?=.*\\\d)(?=.*[\\\u002D-\\\u002E\\\u0040\\\u005F\\\u002A.])(?=.*[A-Z])(?=.*[a-z])\\S{6,}$';
export const SOLICITUD_URL = "https://uatservi2.tutenlabs.dev/clientes/home";
